module.exports = __webpack_public_path__ + "static/media/Stefan_Atz.538bcf81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/redesign/Stefan_Atz.png
// module id = 564
// module chunks = 0